import _ from "lodash";
import { getLearningCourseVariables } from "LearningCourse/modules/Utils";
import { getLearningCourseDetailsFromCache } from "LearningCourse/modules/LearningCourseGraphqlHelpers";

// returns the start and end Dates of the learning course based on terms
export const getLearningCourseTermDates = ({
  learningCourseId,
  academicYearId,
}) => {
  const learningCourseVariables = getLearningCourseVariables({
    learningCourseId,
    academicYearId,
  });
  const learningCourseDetails = getLearningCourseDetailsFromCache(
    learningCourseVariables
  );
  const startDate = _.get(learningCourseDetails, "startDate", null);
  const endDate = _.get(learningCourseDetails, "endDate", null);

  return {
    startDate: _.split(startDate, "T")[0],
    endDate: _.split(endDate, "T")[0],
  };
};
